export default __webpack_public_path__ + "static/media/xps-6uneKLGrJPs-unsplash.09333f86.jpg";